import { Component, OnInit } from '@angular/core';
import { MobileVehiclesService } from 'src/app/services/mobile/mobile-vehicles.service';

@Component({
  selector: 'app-recent-transfers',
  templateUrl: './recent-transfers.component.html',
  styleUrls: ['./recent-transfers.component.css']
})
export class RecentTransfersComponent implements OnInit{
  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  public location_type: string = '';
  page: number = 1;
  count: number = 0;
  vehicles: any[] = [];
  searchText: string = '';

  constructor(
    private mobileVehiclesService: MobileVehiclesService,
  ){}

  ngOnInit(): void {
    this.getRecentlyTransferredVehicles();
  }

  getRecentlyTransferredVehicles():void{
    this.isLoading=true;

    this.mobileVehiclesService.getRecentlyTransferredVehicles()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
           this.vehicles = [];
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
          this.vehicles = [];
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
        this.vehicles = [];
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }
}
